<template>
    <div class="flex">
        <i v-for="option in options" :key="option.value"
            class="mr-1 cursor-pointer ds-text-2xl last:mr-0"
            :class="{
                [option.icon]: true,
                'text-gray-700': option.value === value,
                'text-gray-500': option.value !== value,
            }"
            @click="$emit('input', option.value)"
        />
    </div>
</template>

<script>
    export default {
        props: {
            options: { type: Array, required: true },
            value: { type: String, required: true },
        }
    }
</script>